
export interface INapsPagingRes {
  count: number;
  next: null;
  previous: null;
  numero_paginas: number;
  data: Naps[];
}
export interface Naps {
  id_nap?: string;
  codigo?: string;
  numero_referencia?: string;
  nombre?: string;
  direccion?: string;
  coordenadas?: string;
  latitud?: string;
  longitud?: string;
  estado_nap: boolean;
  proyecto_cod?: string;
  puertos?: CurrentPuertoNap[] | PuertoNap[] | [];
  es_soterrado: boolean;
  nodo?: string; //fk
  olt?: string; // code
  sector?: string;
  ciudad?: string;
  estado: boolean;
  distancia: number;
  distancia_polmax: number;

  caja_primaria?: string
  puertos_disponibles?: number
  puertos_ocupados?: number
  tipo_caja?: string
  operadora?: string
  fecha_instalacion?: string
  user_instalacion?: string
  nombre_tecnico_instalacion?: string
  observaciones?: any
  estado_fisico_nap?:string;
  naps_desfogue?:any;
  todos?:boolean;
}

export interface IDistancia {
  coordenada_1: string;
  coordenada_2: string;
}

export interface PuertoNap {
  estado: EstadoPuertoNap;
  puerto: string;
  id_cliente_contrato?: string | null;
}

export interface CurrentPuertoNap {
  estado: EstadoPuertoNap;
  puerto: string;
  //id de contrato
  id_cliente_contrato: string | null | undefined;
}
export enum EstadoPuertoNap {
  OCUPADO="OCUPADO",
  BLOQUEADO="BLOQUEADO",
  EN_USO="EN USO",
  DISPONIBLE="DISPONIBLE",
  LIBRE="LIBRE"
}

export const EstadoPuertoNapOptions = [
  EstadoPuertoNap.BLOQUEADO,
  EstadoPuertoNap.DISPONIBLE,
  EstadoPuertoNap.OCUPADO
]

export interface NapsQGIS {
  id: number;
  geom: string;
  nombre: string;
  descriptio: string;
  status: string;
  proyecto_cod: string;
  coordenada: string;
  puertos_oc: number;
  fecha_instalacion: string;
  solicita: string;
  sector: string;
  ciudad: string;
  tecnico_in: string;
  potencia: number;
  project_name: string;
  id_poligono: number;
  soterrada: string;
  splitter: string;
  operadora: string;
}

export interface INapsQGISPagingRes {
  count: number;
  next: null;
  previous: null;
  numero_paginas: number;
  data: NapsQGIS[];
}